import { Model } from '@vuex-orm/core'
import { BlackListDto } from './blacklist.interface'
import { Constants } from '@/constants'

export default class BlackList extends Model {
    static entity = 'blacklists'

    static fields() {
        return {
            id: this.attr(null),
            email: this.attr(''),
            name: this.attr('')
        }
    }

    static async createOne(payload: BlackListDto) {
        return await this.api().post(Constants.API.BLACKLIST, payload)
    }

    static async findOne(id: number) {
        return await this.api().get(Constants.API.BLACKLIST + "/" + id)
    }

    static async updateOne(id: number, payload: BlackListDto) {
        return await this.api().patch(Constants.API.BLACKLIST + "/" + id, payload)
    }

    static async removeOne(id: number) {
        return await this.api().delete(Constants.API.BLACKLIST + "/" + id)
    }

    static apiConfig = {
        actions: {
            fetch: {
                method: 'get',
                url: '/blacklists'
            }
        }
    }
}
